import { sortString, sortNumber, toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'PRESCRIPTION_INDIVIDUAL_PEP';

const sort = function (a, b) {
  let result = sortNumber(a.status, b.status);
  if (result !== 0) {
    return result;
  }
  const aName = a.name || null;
  const bName = b.name || null;
  result = sortString(aName, bName);
  if (result !== 0) {
    return result;
  }
  return sortString(a.key, b.key);
};

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterData = (data, term) => {
  const result = data.filter(patient => {
    const patientName = patient.name ? filterByTerm(patient.name, term) : false;
    const patientCPF = patient.cpf ? filterByTerm(patient.cpf, term) : false;
    return patientName || patientCPF;
  });
  if (sort) {
    result.sort(sort);
  }
  return result;
};

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      return {
        ...state,
        loading: false,
        loadedData: action.payload,
        filter: {
          ...state.filter,
          data: action.payload
        }
      };
    }
    case `${TEMPLATE_NAME}_EVALUATION_CREATE`: {
      const newRow = action.payload;
      const loadedData = [...state.loadedData, newRow];
      return {
        ...state,
        loading: false,
        loadedData,
        filter: {
          ...state.filter,
          data: filterData(loadedData, state.filter.term, state.filter.type)
        }
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
